import { FETCH_TRANSLATIONS_SUCCESS, SET_TRANSLATIONS } from './translations-actions';
import { FETCH_TRANSLATIONS_SUCCESS as FETCH_COMMENTS_TRANSLATIONS_SUCCESS } from './comments-translations-actions';

export function translations(state = null, action) {
  switch (action.type) {
    case FETCH_TRANSLATIONS_SUCCESS:
    case SET_TRANSLATIONS:
    case FETCH_COMMENTS_TRANSLATIONS_SUCCESS:
      return { ...action.payload, ...state };
    default:
      return state;
  }
}
